/* Shared, sharded tecinfo loader for product-page widgets. */
(function (global) {
  if (global.SMSTecinfoLoader) return;

  var bucketPromises = Object.create(null);
  var fallbackPromises = Object.create(null);

  function canonicalSku(value) {
    return String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  }

  function bucketSeed(value) {
    var canonical = canonicalSku(value);
    var lettersOnly = canonical.replace(/[0-9]/g, '');
    return lettersOnly || canonical || 'UNKNOWN';
  }

  function bucketNumber(value, count) {
    var seed = bucketSeed(value);
    var hash = 5381;
    for (var index = 0; index < seed.length; index += 1) {
      hash = ((hash << 5) + hash) ^ seed.charCodeAt(index);
    }
    return (hash >>> 0) % count;
  }

  function normalizePayload(payload) {
    if (Array.isArray(payload)) return payload;
    if (payload && Array.isArray(payload.items)) return payload.items;
    if (payload && Array.isArray(payload.records)) return payload.records;
    if (payload && typeof payload === 'object') return [payload];
    return [];
  }

  function fetchJson(url, cache) {
    if (!cache[url]) {
      cache[url] = fetch(url, { cache: 'force-cache' })
        .then(function (response) {
          if (!response.ok) throw new Error(url + ' ' + response.status);
          return response.json();
        })
        .then(normalizePayload)
        .catch(function (error) {
          delete cache[url];
          throw error;
        });
    }
    return cache[url];
  }

  function bucketUrl(baseUrl, bucket) {
    return baseUrl + String(bucket).padStart(2, '0') + '.json';
  }

  global.SMSTecinfoLoader = {
    bucketNumber: bucketNumber,
    loadForSkus: function (options) {
      options = options || {};
      var baseUrl = String(options.baseUrl || '');
      var fallbackUrl = String(options.fallbackUrl || '');
      var count = Math.max(1, Number(options.bucketCount) || 64);
      var skus = Array.isArray(options.skus) ? options.skus : [];

      if (!baseUrl || !skus.length) {
        if (!fallbackUrl) return Promise.resolve([]);
        return fetchJson(fallbackUrl, fallbackPromises);
      }

      var bucketIds = [];
      var seen = Object.create(null);
      skus.forEach(function (sku) {
        var id = bucketNumber(sku, count);
        if (!seen[id]) {
          seen[id] = true;
          bucketIds.push(id);
        }
      });

      return Promise.all(bucketIds.map(function (id) {
        return fetchJson(bucketUrl(baseUrl, id), bucketPromises);
      })).then(function (groups) {
        return groups.reduce(function (records, group) {
          return records.concat(group);
        }, []);
      }).catch(function (error) {
        if (!fallbackUrl) throw error;
        console.warn('[Tecinfo] Bucket load failed; using full-data fallback.', error);
        return fetchJson(fallbackUrl, fallbackPromises);
      });
    }
  };
})(window);

